import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{this.heading}}
*/
{
  "id": "Z5RPI5Lp",
  "block": "[[[1,[30,0,[\"heading\"]]]],[],false,[]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/toolbar-popup-menu-options/toolbar-popup-menu-options-heading.hbs",
  "isStrictMode": false
});